import React from 'react';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';
import { textCaption } from '../../styles/typography';

export const AuthorPosition = ({
  children,
  className,
  as: Component = 'div',
  disableMobile,
  ...props
}: DefaultBsComponent & { disableMobile?: boolean }) => {
  return (
    <Component
      {...props}
      className={classNames(
        'AuthorName',
        disableMobile && 'hidden lg:block',
        className,
        textCaption,
        'text-neutral-101',
      )}
    >
      {children}
    </Component>
  );
};
